import { Directive, ElementRef, Input } from '@angular/core';
import { util } from '../util';

// for 'a' elements (links) there is no proper way to remove disabled attribute after it has been added - https://css-tricks.com/how-to-disable-links/
// instead use css class 'disabled' on the element

@Directive({
  selector: '[busyButton]'
})
export class BusyButtonDirective {
  private busy:boolean;
  private readonly element:HTMLInputElement;

  constructor(
    public elementRef:ElementRef
  ) {
    this.element = this.elementRef.nativeElement;
  }

  @Input() bbReplaceIcon:boolean;
  @Input() bbPreventDisable:boolean;
  @Input() bbIconMargin?:boolean;
  @Input() bbReplaceContents?:boolean;

  @Input()
  public set busyButton(condition:boolean) {
    this.busy = condition;

    if (this.element) {
      const elementIsLink:boolean = this.element.tagName === 'A';
      const getIcon:Function = ():HTMLElement => this.element.querySelector('i');

      if (util.isUndefined(this.bbIconMargin)) {
        this.bbIconMargin = !this.bbReplaceIcon && !this.bbReplaceContents;
      }

      if (util.notNullOrUndefinedOrEmpty(condition) && condition) {
        if (this.bbReplaceIcon) {
          getIcon()?.classList.add('d-none');
        }
        this.element.insertAdjacentHTML('afterbegin', `<i class="fa fa-spinner fa-spin activity-indicator ${!this.bbIconMargin? 'no-margin' : ''}"></i>`);
        if(!this.bbPreventDisable) {
          if(elementIsLink){
            this.element.classList?.add('disabled');
          } else {
            this.element.disabled = true;
          }
        }
      } else {
        const childElement:Element = this.element.querySelector('.activity-indicator');
        if(childElement) {
          this.element.removeChild(childElement);
          if (!this.bbPreventDisable) {
            if(elementIsLink){
              this.element.classList?.remove('disabled');
            } else {
              this.element.disabled = false;
            }
          }
        }
        if (this.bbReplaceIcon) {
          getIcon()?.classList.remove('d-none');
        }
      }

    }
  }

  public get busyButton():boolean {
    return this.busy;
  }
}